import { memo, useMemo } from "react";
import { Link } from "react-router-dom";
import "./collection.css";

import { getProductImageUrl } from "../../../utils/imageUrl";

const ArrowRightIcon = () => (
	<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="ml-5 hidden h-7 w-7 md:block" aria-hidden="true" focusable="false">
		<path d="M5 12h14M13 6l6 6-6 6" />
	</svg>
);

function Collections({ data = [], latestYear = 2027 }) {
	const cards = useMemo(() => {
		const details = [
			{ text: "Step Into Style", alt: "Featured Azure style 1" },
			{ text: "Shine With Grace", alt: "Featured Azure style 2" },
			{ text: "Wear Your Bold", alt: "Featured Azure style 3" },
		];

		const featured = Array.isArray(data)
			? data
					.filter((item) => item.viewInfront === true)
					.sort((a, b) => Number(b.year || 0) - Number(a.year || 0))
					.slice(0, 3)
			: [];

		return details.map((detail, index) => ({ ...detail, product: featured[index] }));
	}, [data]);

	if (!cards.some((card) => card.product)) return null;

	return (
		<section className="mb-20 px-4 md:px-10" aria-labelledby="signature-style-heading">
			<div className="mb-20 text-center font-lora text-3xl font-semibold md:text-5xl">
				<h2 id="signature-style-heading">Discover Your Signature Style</h2>
			</div>

			<div className="grid grid-cols-1 gap-5 py-10 font-lora md:grid-cols-2 md:px-10 lg:grid-cols-3">
				{cards.map((card, index) => {
					if (!card.product) return null;
					const imageSource = getProductImageUrl(card.product, 0);
					const linkRoute = `/product/id/${card.product.style}`;
					const imageAlt = card.product.style ? `Azure dress ${card.product.style}` : card.alt;

					return (
						<Link
							key={card.product._id || card.product.id || card.product.style || index}
							to={linkRoute}
							state={{ product: card.product }}
							aria-label={`View ${card.product.style || card.text}`}
							className="group relative h-[500px] w-full overflow-hidden md:h-[700px]"
						>
							<img
								src={imageSource}
								alt={imageAlt}
								loading="lazy"
							 fetchPriority="high"
								decoding="async"
								width="700"
								height="900"
								className={`h-full w-full object-cover transition-transform duration-500 group-hover:scale-105 ${index === 0 ? "object-left-top" : index === 1 ? "object-center" : "object-right-top"}`}
							/>
							<div className="absolute inset-0 flex items-end justify-end pb-8 pr-8">
								<span className="flex items-center justify-center rounded-lg bg-[#1f4c94]/90 p-3 text-[20px] font-bold uppercase tracking-wider text-white shadow-xl transition-transform duration-500 ease-in-out">
									{card.text}<ArrowRightIcon />
								</span>
							</div>
						</Link>
					);
				})}
			</div>
		</section>
	);
}

export default memo(Collections);
